/** type {Record<string,string>} dict */
export default {
  "layout.skipToContent": "Skip to content",

  "hero.title": "Upload Your 3D Model\nGet an Instant Price in Seconds",
  "hero.subtitle":
    "Upload your STL or OBJ file, choose your print settings, and get an instant price estimate for 3D printing.",

  "cta.upload": "Upload Model",
  "cta.seePrice": "See Price",
  "cta.getQuote": "Get a Quote",

  "trust.instant": "Instant pricing",
  "trust.fast": "Fast production",
  "trust.delivery": "Delivery across Turkey",
  "trust.quality": "Professional quality prints",

  "how.eyebrow": "HOW IT WORKS",
  "how.title": "How It Works",
  "how.description": "Upload your file, choose print settings, and see your price right away.",
  "how.step1": "Upload your 3D model",
  "how.step2": "Choose print settings",
  "how.step3": "Get your price instantly",

  "price.title": "Estimated Price",
  "price.subtitle": "This price is based on your selected print settings",
  "price.question": "Want us to print this model?",
  "price.cta": "🚀 Get a Quote",

  "quote.title": "Get Your Custom Quote",
  "quote.subtitle": "Only your name and phone number are required",
  "quote.submit": "Get Quote",

  "success.title": "Your request has been received 🚀",
  "success.subtitle": "We’ll get back to you shortly",

  "whatsapp.title": "Want a faster response?",
  "whatsapp.cta": "💬 Message us on WhatsApp",
  "whatsapp.floatingMessage":
    "Hi, I uploaded a 3D model on your website. I would like to get more information about the quote.",

  "loading.title": "Analyzing your model...",
  "loading.subtitle": "Calculating volume, weight, and print time",

  "viewer.badge.preview": "Preview",
  "viewer.badge.live": "Live",
  "viewer.reset": "Reset",
  "viewer.empty.title1": "Upload your model,",
  "viewer.empty.title2": "preview it in 3D here.",
  "viewer.empty.formats": "STL · OBJ · STEP · 3MF supported",
  "viewer.loading": "Parsing model…",
  "viewer.error.title": "Preview error",
  "viewer.error.fallback": "Could not render the model.",
  "viewer.error.unsupportedFormat": "Unsupported format. Upload STL / OBJ / STEP / 3MF.",
  "viewer.error.readFailed": "Could not read the file.",
  "viewer.error.parseFailed": "Could not parse the model. The file may be corrupt.",
  "viewer.hint.rotate": "Left drag · Rotate",
  "viewer.hint.pan": "Right drag · Pan",
  "viewer.hint.zoom": "Scroll · Zoom",
  "viewer.step.title": "STEP file received",
  "viewer.step.body":
    "Your STEP file has been received. Preview is currently supported for STL and OBJ. Our engineering team will review your STEP file and prepare a quote.",

  "viewer.3mf.title": "3MF file received",
  "viewer.3mf.body":
    "Your 3MF file is being analyzed. Browser preview is supported for STL and OBJ — a price estimate will appear shortly.",

  "ai.panel.title": "Model Analysis",
  "ai.panel.subtitle": "Automatic preliminary assessment",
  "ai.loading": "Preparing analysis…",
  "ai.row.fileType": "File type",
  "ai.row.printability": "Print suitability",
  "ai.row.method": "Suggested method",
  "ai.row.materials": "Suggested materials",
  "ai.row.risks": "Risk note",
  "ai.row.nextStep": "Next step",
  "ai.meta.section": "Technical metadata",
  "ai.meta.dimensions": "Dimensions",
  "ai.meta.volume": "Estimated volume",
  "ai.meta.triangles": "Triangles (mesh)",
  "ai.meta.orientation": "Suggested orientation",
  "ai.disclaimer":
    "This analysis is for preliminary assessment only. Final production suitability is confirmed after technical review.",
  "ai.supportRisk.low": "Low",
  "ai.supportRisk.medium": "Medium",
  "ai.supportRisk.high": "High",

  "ai.val.printability.pending": "Under review",
  "ai.val.printability.ok": "Looks printable",
  "ai.val.printability.stepPreview": "STEP received • preview supported for STL/OBJ",
  "ai.val.method.fdmDefault": "FDM (default) — SLA for fine detail",
  "ai.val.method.slaDetail": "SLA / DLP (high resolution)",
  "ai.val.method.afterReview": "Determined after engineering review",
  "ai.val.materials.plaPetg": "PLA / PETG • ABS or Nylon for strength",
  "ai.val.materials.byUseCase": "Will be recommended for your application",
  "ai.val.nextStep":
    "Submit the quote form so our team can review your file and get back to you.",
  "ai.val.risk.largePart":
    "Large part: segmented production or a large-format bed may be required.",
  "ai.val.risk.smallScale": "Very small scale: SLA resin recommended — risk of detail loss.",
  "ai.val.risk.thinWalls":
    "Thin walls or support needs should be checked before production.",
  "ai.val.risk.meshDense": "High mesh density — remesh optimization may be recommended.",
  "ai.val.risk.stepFile":
    "STEP is a parametric format — final assessment will be done by our engineering team.",
  "ai.val.orient.xy": "XY base (Z up)",
  "ai.val.orient.xz": "XZ base (Y up)",
  "ai.val.orient.yz": "YZ base (X up)",

  "nav.home": "Home",
  "nav.services": "Services",
  "nav.materials": "Materials",
  "nav.portfolio": "Portfolio",
  "nav.about": "About",
  "nav.contact": "Contact",

  "lang.tr": "TR",
  "lang.en": "EN",
  "lang.switchAria.tr": "Switch language to Turkish",
  "lang.switchAria.en": "Switch language to English",

  "header.uploadModel": "Upload Model",
  "header.themeAriaToLight": "Switch to light theme",
  "header.themeAriaToDark": "Switch to dark theme",
  "header.theme.light": "Light",
  "header.theme.dark": "Dark",
  "header.theme.mobile.light": "Light theme",
  "header.theme.mobile.dark": "Dark theme",
  "header.menuAria": "menu",

  "footer.tagline":
    "Turkey-focused engineering-grade 3D printing and rapid prototyping. From idea to physical parts in hours.",
  "footer.pages": "Pages",
  "footer.contactSection": "Contact",
  "footer.legalPrivacy": "Privacy Policy",
  "footer.legalKvkk": "Personal Data Disclosure (KVKK)",
  "footer.legalTerms": "Terms of Use",
  "footer.copyright": "All rights reserved.",
  "footer.madeIn": "Made in Türkiye · Production aligned with quality standards",

  "cta.eyebrow": "NEXT STEP",
  "cta.headline.line1": "Upload your file.",
  "cta.headline.line2.bold": "Within hours",
  "cta.headline.line3": "move into production.",
  "cta.body":
    "Our engineering team prepares your quote within 1–2 hours. If it fits workflow, manufacturing can start the same day.",
  "cta.uploadModel": "Upload Model",
  "cta.seePrice": "See Price",

  "home.heroEyebrow": "Türkiye · Instant Quote · 24-Hour Production",
  "home.heroTitle1": "Upload Your 3D Model,",
  "home.heroTitle2": "See the Price in 30 Seconds",
  "home.heroSub":
    "Upload your STL or OBJ file, choose print settings, and get an instant estimated price — submit, and receive a confirmed quote within 1–2 hours.",

  "home.heroCta.upload": "Upload Model",
  "home.heroCta.price": "See Price",

  "home.heroLiveBadge": "LIVE MANUFACTURING",
  "home.heroCard.line1": "Printer_07 · Batch #2841",
  "home.heroCard.line2": "PA12 prototype · 78% complete",

  "home.trust1": "Production-ready file check",
  "home.trust2": "Nationwide shipping (Türkiye)",
  "home.trust3": "Confirmed quote in 1–2 hours",
  "home.trust4": "NDA protected",

  "home.metrics.lead.label": "Typical turnaround",
  "home.metrics.materials.label": "Materials & colors",
  "home.metrics.projects.label": "Completed projects",
  "home.metrics.shipping.label": "Provinces served",

  "home.how.eyebrow": "How it works",
  "home.how.title": "Production-ready in three steps",
  "home.how.description": "Skip the bureaucracy — upload, approve the quote, receive your shipment.",
  "home.how.step": "Step",
  "home.how.s1.title": "Upload Your Model",
  "home.how.s1.desc": "Drag-and-drop STL, OBJ, STEP or 3MF. Choose material and timeframe.",
  "home.how.s2.title": "See the Price",
  "home.how.s2.desc": "Instant price band — our team confirms the final quote shortly after.",
  "home.how.s3.title": "Production & Delivery",
  "home.how.s3.desc": "Production starts once approved; fast courier delivery across Türkiye.",

  "home.services.eyebrow": "Our Services",
  "home.services.title": "From Idea to Parts. One Platform.",
  "home.services.description":
    "From FDM and SLA resin printing to low-volume manufacturing — engineered 3D production.",

  "home.why.eyebrow": "Why {brand}",
  "home.why.title": "Design to delivery. One engineering crew.",
  "home.why.desc": "We are not \"just printing\" — we partner through the whole lifecycle.",
  "home.why.more": "Learn more about us",

  "home.feature1.title": "Fast Manufacturing",
  "home.feature1.desc": "Physical prototypes within 48h. Same-day courier option inside Istanbul.",
  "home.feature2.title": "Engineering Quality",
  "home.feature2.desc": "Every file is reviewed by an engineer.",
  "home.feature3.title": "Material Guidance",
  "home.feature3.desc": "We recommend the optimal material stack for your use case.",
  "home.feature4.title": "Direct Communication",
  "home.feature4.desc": "One owner, one channel — WhatsApp or email.",
  "home.feature5.title": "Nationwide Coverage",
  "home.feature5.desc": "Ships to every province via contracted logistics (24–72h).",
  "home.feature6.title": "Confidentiality & NDA",
  "home.feature6.desc": "NDA coverage and encrypted uploads for sensitive projects.",

  "home.materials.eyebrow": "Materials",
  "home.materials.title": "Pick the material that matches your project.",
  "home.materials.all": "Browse all materials",

  "home.material.inStock.yes": "In stock",
  "home.material.inStock.no": "Out of stock",

  "home.portfolio.eyebrow": "Portfolio",
  "home.portfolio.title": "Selections from production.",
  "home.portfolio.all": "View all projects",

  "home.marquee.1": "500+ parts produced",
  "home.marquee.2": "Fast delivery",
  "home.marquee.3": "Professional grade",
  "home.marquee.4": "Customers across Türkiye",

  "home.trustBlock":
    "We ship across Türkiye. Engineering teams, startups and manufacturers rely on {brand}.",

  "home.faq.eyebrow": "FAQ",
  "home.faq.title": "Answers, right here.",
  "home.faq.description": "Straight answers — if yours is missing, ask us on WhatsApp.",
  "home.faq.whatsappCta": "Ask via WhatsApp",

  "quote.hero.eyebrow": "GET A QUOTE",
  "quote.hero.line1": "Upload your file.",
  "quote.hero.highlight": "Preview in 3D.",
  "quote.hero.line2": "Get your quote.",
  "quote.hero.sub":
    "Browser preview plus server-side estimates for STL/OBJ; STEP reviewed by engineering before quoting. Typical response within 1–2 hours.",

  "quote.upload.title": "Upload your 3D model",
  "quote.upload.sub": "Get an instant price estimate — STL, OBJ, STEP or 3MF.",
  "quote.upload.hint": "or click to browse · max 100 MB",
  "quote.upload.badges.max": "max 100MB",

  "quote.uploaded": "Uploaded",

  "quote.expect.stl": "STL → Instant price estimate",
  "quote.expect.obj": "OBJ → Approximate price estimate",
  "quote.expect.step": "STEP → Priced after technical review",
  "quote.expect.3mf": "3MF → Instant price estimate",
  "quote.expect.stlRest": "Instant price estimate",
  "quote.expect.objRest": "Approximate price estimate",
  "quote.expect.stepRest": "Priced after technical review",
  "quote.expect.3mfRest": "Instant price estimate",

  "quote.print.title": "Print settings",
  "quote.print.description":
    "The preview price follows these selections; STL/OBJ will refresh instantly when inputs change.",

  "quote.label.material": "Material *",
  "quote.materialSuggest": "Recommend a material",

  "quote.label.infill": "Infill %",
  "quote.label.walls": "Wall count",
  "quote.label.layer": "Quality / layer height",
  "quote.label.quality": "Quality profile",

  "quote.quality.Ekonomik": "Economy",
  "quote.quality.Standart": "Standard",
  "quote.quality.Dayanıklı": "Durable",
  "quote.quality.Detaylı": "Fine detail",

  "quote.trust":
    "Your file stays confidential — used only for quoting. Signed NDAs available on request.",

  "quote.stats.response": "Avg. reply",
  "quote.stats.responseVal": "1–2 h",
  "quote.stats.start": "Production start",
  "quote.stats.sameDay": "Same day",
  "quote.stats.delivery": "Delivery",
  "quote.stats.deliveryVal": "24–72 h",
  "quote.stats.privacy": "Privacy",
  "quote.stats.nds": "NDA protected",

  "quote.preview.hint":
    "Preview your model, verify orientation, then request a tailored quote.",

  "quote.funnel.title": "Want us to manufacture this model?",
  "quote.funnel.desc": "Share your info for schedule and precise pricing — our team replies fast.",
  "quote.funnel.cta": "Get a Quote",

  "quote.form.title": "Let us send you a custom quote",
  "quote.form.subtitle": "Name and phone are enough — email and notes are optional.",

  "quote.field.fullName": "Full name",
  "quote.field.phone": "Phone",
  "quote.field.email": "Email (optional)",
  "quote.field.quantity": "Quantity (optional)",
  "quote.field.notes": "Notes (optional)",

  "quote.submit.sending": "Sending…",
  "quote.submit.cta": "Get a Quote",
  "quote.whatsappSend": "Send via WhatsApp",
  "quote.footerNote": "Name and phone are required. Data is used only for quoting.",

  "quote.placeholder.name": "John Doe",
  "quote.placeholder.phone": "+90 …",
  "quote.placeholder.email": "you@company.com",
  "quote.placeholder.notes": "Tolerance, deadline, finish expectations…",

  "toast.priceReady": "Your price is ready 🎉",
  "toast.needNamePhone": "Please enter your name and phone.",
  "toast.requestReceived": "Your request has been received 🚀",
  "toast.errorGeneric": "Something went wrong. Please try again.",
  "toast.unsupportedFormat": "Unsupported format. Allowed:",
  "toast.fileTooBig": "File is too large (max 100MB)",
  "toast.priceUpdateFailed":
    "Couldn't refresh the price — re-select your file or try again later.",
  "quote.3mf.settingsApplied": "Print settings from the 3MF file were applied",
  "quote.3mf.detectedTitle": "3MF settings detected",
  "quote.3mf.detectedSubtitle": "This price reflects the print settings inside your 3MF file.",
  "quote.3mf.detectedAccuracy": "This estimate is more accurate because it uses the print settings from your 3MF file.",
  "quote.3mf.updatedByUser": "Settings updated by user",
  "quote.3mf.overrideSubtitle":
    "The current estimate uses your form selections below; the list shows the values first read from the 3MF file.",
  "quote.3mf.overrideAccuracy": "The list is for reference only; the range reflects your current selections.",
  "quote.3mf.infill": "Infill",
  "quote.3mf.walls": "Walls",
  "quote.3mf.layer": "Layer",
  "quote.3mf.quality": "Quality",

  "quote.success.title": "Your request has been received 🚀",
  "quote.success.byline": "Hi {{name}}",
  "quote.success.helloPrefix": "Hey",
  "quote.success.guest": "friend",
  "quote.success.followup": "Our team will get back shortly.",
  "quote.success.emailLabel": "We'll update you here:",
  "quote.success.whatsappAsk": "Want to jump straight to WhatsApp?",
  "quote.success.home": "Home",
  "quote.success.whatsDone": "💬 Message now",

  "price.card.title": "Estimated Price",
  "price.card.subtitle": "This price is based on your selected print settings",

  "price.badge.pending": "Review required",
  "price.badge.analyzingLabel": "Analyzing",

  "price.level.high": "Close to definitive",
  "price.level.medium": "Estimate",
  "price.level.low": "Rough estimate",

  "price.fallback.noFile": "Approximate pricing appears here once you upload a file.",
  "price.fallback.analyzing": "Analyzing the model — your estimate will appear shortly.",
  "price.fallback.pendingReview": "Engineering reviews this model before final pricing.",
  "price.fallback.technicalReview": "Priced after technical review.",

  "price.review.tooDetailed": "This model is very detailed and requires manual review.",
  "price.review.timeout": "Analysis timed out. Our team will review the file and get back to you.",
  "price.review.generic3mf":
    "We could not derive volume or mesh data from this 3MF; manual review is required.",

  "price.3mf.reviewCardTitle": "This 3MF file needs a technical review.",
  "price.3mf.reviewCardBody": "Our team will check the file and get back to you.",

  "price.loading.title": "Analyzing your model…",
  "price.loading.line1": "Calculating volume, grams and runtime",
  "price.loading.line2": "Typically a few seconds",

  "price.range.label": "Approximate range (incl. VAT)",

  "price.support.prefix": "Support risk:",
  "price.support.low": "Low",
  "price.support.medium": "Medium",
  "price.support.high": "High",

  "price.hint.label": "Tip:",
  "price.hint.body": "Lowering infill unlocks cheaper pricing bands.",

  "price.cta.askProduce": "Want production for this exact model?",
  "price.cta.primary": "🚀 Get a quote now",
  "price.collapsible.title": "How was this priced?",

  "price.detail.infill": "Infill",
  "price.detail.walls": "Walls",
  "price.detail.layer": "Layer height",
  "price.detail.material": "Material",
  "price.detail.duration": "Time estimate",
  "price.detail.durationUnit": "h",
  "price.detail.gram": "Weight estimate",
  "price.detail.dimensions": "Envelope (bounding box)",
  "price.detail.triangles": "Triangles",

  "price.disclaimer":
    "Final numbers depend on print time, support strategy and QC — confirmed after engineer review.",

  "price.sidebar.form": "For a binding quote",
  "price.sidebar.formBold": "tap the button — specialists respond fast.",
  "price.sidebar.expertLead": "Connect with an engineer instantly.",
  "price.sidebar.expertBtn": "Chat on WhatsApp",

  "units.hours": "h",
  "dash": "—",

  "contact.eyebrow": "CONTACT",
  "contact.hero.row1": "Let's talk.",
  "contact.hero.bold": "Turn your concept",
  "contact.hero.rest": "into a physical part.",
  "contact.hero.sub":
    "WhatsApp replies fastest — use the form or email below for heavier documentation.",

  "contact.row.phone": "Phone",
  "contact.row.email": "Email",
  "contact.row.whatsapp": "WhatsApp",
  "contact.row.address": "Address",
  "contact.hours.title": "Opening hours",

  "contact.field.name": "Full name *",
  "contact.field.email": "Email *",
  "contact.field.phone": "Phone",
  "contact.field.subject": "Subject",
  "contact.field.message": "Message *",

  "contact.placeholder.subject": "Project kickoff chat",
  "contact.placeholder.message": "Tell us briefly about the project…",

  "contact.submit.sending": "Sending…",
  "contact.submit.cta": "Send message",
  "contact.whats.cta": "Message on WhatsApp",

  "toast.contact.missing": "Please fill in name, email and message.",
  "toast.contact.ok": "Got it — we'll reply ASAP.",
  "toast.contact.fail": "Something went wrong.",

  "materials.eyebrow": "MATERIALS",
  "materials.hero.line1": "The right material",
  "materials.hero.highlight": "for every build.",
  "materials.hero.sub":
    "50+ options available — ping us if you are unsure which stack fits.",

  "materials.empty.desc":
    "Try different filters once your catalog refreshes — or chat with engineering.",
  "materials.empty.home": "Return home",

  "materials.compareTitle": "Comparison table",
  "materials.compareSubtitle": "Which material fits your workload?",
  "materials.table.mat": "Material",
  "materials.table.use": "Use case",
  "materials.table.heat": "Heat",
  "materials.table.strength": "Strength",
  "materials.table.detail": "Detail",

  "materials.row.pla.use": "Prototype / model",
  "materials.row.petg.use": "Functional / outdoor",
  "materials.row.abs.use": "Industrial / automotive",
  "materials.row.resin.use": "Jewellery / dental / micro parts",
  "materials.row.nylon.use": "Industrial functional",
  "materials.row.tpu.use": "Flexible / gasket",

  "materials.row.pla.strength": "Medium",
  "materials.row.petg.strength": "High",
  "materials.row.abs.strength": "High",
  "materials.row.resin.strength": "Medium",
  "materials.row.nylon.strength": "Very high",
  "materials.row.tpu.strength": "Flexible",

  "materials.row.pla.detail": "High",
  "materials.row.petg.detail": "High",
  "materials.row.abs.detail": "Medium",
  "materials.row.resin.detail": "Ultra high",
  "materials.row.nylon.detail": "High",
  "materials.row.tpu.detail": "High",

  "materials.stock.in": "In stock",
  "materials.stock.out": "Out of stock",

  "services.eyebrow": "SERVICES",
  "services.hero.line1": "Production-grade",
  "services.hero.highlight": "additive manufacturing.",
  "services.hero.sub":
    "Rapid prototyping, functional parts, architecture models & low-volume runs — centralized.",

  "services.detail.fdm.0": "Fine layers down to 0.1 mm",
  "services.detail.fdm.1": "500 × 500 × 600 mm build volume",
  "services.detail.fdm.2": "PLA, PETG, ABS, ASA, nylon grades, CFR",
  "services.detail.resin.0": "25 µ XY resolution",
  "services.detail.resin.1": "Jewellery, dental shells, micron features",
  "services.detail.resin.2": "Tough, flexible, transparent, castable resins",
  "services.detail.prototype.0": "Physical prototypes within two days",
  "services.detail.prototype.1": "Design-for-manufacturing coaching",
  "services.detail.prototype.2": "Iterate quickly with engineering feedback",
  "services.detail.functional.0": "Industrial durability",
  "services.detail.functional.1": "Nylon PA12, carbon-filled blends",
  "services.detail.functional.2": "Post-processing & assemblies",
  "services.detail.architecture.0": "Architectural scales 1:50 – 1:1000",
  "services.detail.architecture.1": "White SLA or large-format FDM",
  "services.detail.architecture.2": "Urban context & facade crispness",
  "services.detail.batch.0": "10 – 1000 pcs",
  "services.detail.batch.1": "QC dossiers optional",
  "services.detail.batch.2": "Consolidated logistics",

  "portfolio.eyebrow": "PORTFOLIO",
  "portfolio.hero.line1": "Highlights",
  "portfolio.hero.highlight": "from the floor.",
  "portfolio.hero.sub": "Industrial parts, architecture models and functional prototyping.",

  "portfolio.filter.all": "All",
  "portfolio.empty.filter": "Try another category",
  "portfolio.empty.none": "No projects match this category — adjust the filter.",
  "portfolio.cmsEmpty": "Projects will appear here once added in the CMS.",
  "portfolio.empty.resultsTitle": "No results",

  "about.eyebrow": "ABOUT",
  "about.hero.line1": "Engineering-first",
  "about.hero.highlight": "additive manufacturing.",
  "about.intro":
    "{brand} is a rapid fabrication lab founded by mechanical engineers and product designers. We focus on translating intent into workable hardware — beyond simple printing.",

  "about.alt.main": "3D printing",

  "about.pillar1.title": "Technology Stack",
  "about.pillar1.body":
    "Industrial FDM, SLA/DLP resin and nylon SLS setups cover prototyping through production volumes.",
  "about.pillar2.title": "Design Enablement",
  "about.pillar2.body": "Hands-on Design-for-Manufacturing input so geometries survive real loads.",
  "about.pillar3.title": "Single Point of Contact",
  "about.pillar3.body": "One accountable engineer owns your job — Slack / WhatsApp / email without theatre.",
  "about.pillar4.title": "Confidential programs",
  "about.pillar4.body": "NDAs, segmented storage and granular access paths for OEM programs.",

  "about.valuesEyebrow": "WHAT WE CARE ABOUT",
  "about.valuesTitle": "Velocity, fidelity, ruthless clarity.",

  "about.v1.title": "Velocity",
  "about.v1.body": "Tight quoting and manufacturing timelines — clocks matter.",
  "about.v2.title": "Craft",
  "about.v2.body": "Pieces are inspected — we do not ship out-of-spec parts.",
  "about.v3.title": "Clarity",
  "about.v3.body": "Straight answers — no jargon walls.",

  "notfound.label": "Error 404",
  "notfound.title": "Page not found",
  "notfound.body": "The page moved or maybe never existed.",
  "notfound.home": "Back to homepage",

  "whatsapp.aria": "WhatsApp",
  "whatsapp.brand": "WhatsApp",

  "empty.defaults.title": "No results found",
  "empty.defaults.desc": "Try adjusting filters.",
  "empty.defaults.action": "Clear filters",

  "price.whatsapp.prefill":
    "Hi — my STL is around {{volume}} cm³ and shows ~{{low}}–{{high}} TRY. I'd like engineer input.",
  "price.whatsapp.prefill.generic": "Hi — I need engineer support for my 3D print project.",

  "faq.whatsapp.intro": "Hi — I couldn't find what I needed in the FAQ.",

  "quote.whatsapp.intro": "Hi — I'd like to continue on WhatsApp for my pricing request.",

  "quote.upload.whatsapp.intro":
    "Hi — I uploaded my model via the DEKOSTA3D quoting flow.",

  "quote.success.wa.intro":
    "Hi — I just submitted via the quoting form.",

  "marquee.sep": "|",
};
